import { GET_PROJECT_BY_ID, GET_PROJECT_COUNTS, GET_PROJECTS } from "../actions/ActionTypes";
const initialState = {
  data: [],
  page: 1,
  total: 0,
  totalPages: 0,
  isLoading: true,
  projectDetails: null,
  projectCounts: { totalApplications: [], topArtForms: [] },
};

const initial = false;

function ProjectReducer(state = initialState, actions) {
  if (actions.type === GET_PROJECTS) {
    return {
      ...state,
      ...actions.payload,
    };
  }
  if (actions.type === GET_PROJECT_BY_ID) {
    return {
      ...state,
      projectDetails: actions.payload,
    };
  }
  if (actions.type === GET_PROJECT_COUNTS) {
    return {
      ...state,
      projectCounts: actions.payload,
    };
  }
  if (
    actions.type === "LOADING" &&
    (actions.payload.action_model === GET_PROJECTS ||
      actions.payload.action_model === GET_PROJECT_BY_ID)
  ) {
    return {
      ...state,
      isLoading: actions.payload.loading,
    };
  }
  return state;
}

export { ProjectReducer };
